import * as types from '../mutation-types'

// initial state
const state = {
  sportResultsLang: {},
  sportResultsDateList: [],
}

// getters
const getters = {
  sportResultsLang: state => state.sportResultsLang,
  sportResultsDateList: state => state.sportResultsDateList,
}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.SPORTRESULT_LANG] (state, payload ) {
    state.sportResultsLang = payload
  },

  [types.SPORTRESULT_DATELIST] (state, payload ) {
    state.sportResultsDateList = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/sport-result.js